import React, {useRef, useState, useEffect, useCallback, memo, PropsWithChildren} from "react";
import { useIntl } from "umi";
import {Input, Button} from "tea-component";
import SvgIcon from "@/pages/home/components/SvgIcon";

interface ChatInputProps extends PropsWithChildren<any>{
	showStop: boolean,
	onSend: Function,
	onStop: Function,
	minRows?: number,
	maxRows?: number,
	className?: string,
}

export default memo(function ChatInput(props: ChatInputProps) {
	
	const {formatMessage} = useIntl();
	
	const {
		showStop,
		onSend, // 发送按钮事件
		onStop, // 停止按钮事件
		minRows = 1,
		maxRows = 11,
		className=""
	} = props;
	const [value, setValue] = useState('');
	const [rows, setRows] = useState(minRows);
	const inputRef = useRef<any>(null);
	
	const updateRow = useCallback(() => {
		if (!inputRef.current) return;
		
		const target = inputRef.current as HTMLTextAreaElement;
		const prevRows = target.rows;
		target.rows = minRows;
		
		// eslint-disable-next-line no-bitwise
		const currentRows = ~~(target.scrollHeight / 22); // 22是文字行高
		if (currentRows === prevRows) {
			target.rows = currentRows;
			return;
		}
		if (currentRows >= maxRows) {
			target.rows = maxRows;
			target.scrollTop = target.scrollHeight;
		}
		setRows(currentRows < maxRows ? currentRows : maxRows);
		
	}, [inputRef, maxRows, minRows]);
	useEffect(() => {
		if (value === '') {
			setRows(1);
		} else {
			updateRow();
		}
	}, [updateRow, value]);
	
	// 发送按钮
	const handleSend = () => {
		
		value && value.trim() && onSend?.(value)
		// 发送后, 输入框置空
		setValue("");
		// 发送后, 输入框获取焦点
		// inputRef.current?.focus()
	}
	// shift+enter 换行
	const handleInputKeyDown = (event) => {
		if (event.shiftKey && event.keyCode === 13) {
			// 阻止默认行为
			event.preventDefault()
			// shift+enter 换行
			const textarea = inputRef.current;
			// 插入换行
			const cursorPosition = textarea.selectionStart
			const currentValue = textarea.value
			textarea.value = `${currentValue.substring(0, cursorPosition)}\n${currentValue.substring(cursorPosition)}`
			textarea.setSelectionRange(cursorPosition + 1, cursorPosition + 1)
			setValue(textarea.value)
		}
	};
	// 回车
	const handlePressEnter = (value, event) => {
		//  在等待回复的时候, 禁用回车发送功能
		if (!showStop) handleSend()
		event.preventDefault();
	};
	return (
		<div className={`${className} dbl-chat-input ${showStop ? "dbl-chat-input-disabled" : ""}`}>
			<Input.TextArea
				ref={inputRef}
				className={"dbl-chat-input-textArea"}
				rows={rows}
				value={value}
				onChange={(value) => setValue(value)}
				onKeyDown={handleInputKeyDown}
				onPressEnter={handlePressEnter}
				placeholder={formatMessage({id: "dbl_gpt_input_placeholder"})}
				disabled={showStop}
			/>
			{
				showStop ?
					(<Button className={"chat-input-btn stop"}  type="weak" onClick={onStop}><SvgIcon type={"aigc-stop"}/>{formatMessage({id: "dbl_gpt_stop"})} </Button>) :
					(<Button className={"chat-input-btn chat-input-btn-send"} type="primary" onClick={handleSend}><SvgIcon type={"datalab-send"}/> {formatMessage({id: "dbl_gpt_send"})} </Button>)
			}
		</div>
	
	
	);
})